import { EUserRoleIDs } from '@feathr/blackbox';

import useAccount from './useAccount';
import useFlags from './useFlags';
import type { TUseRole } from './useRole.utils';
import { deriveRoleFlags } from './useRole.utils';
import useStore, { assertAuthenticatedStore } from './useStore';
import useUser from './useUser';

export type { TUseRole } from './useRole.utils';

function useRole(): TUseRole {
  const store = useStore();
  assertAuthenticatedStore(store);

  const { isPlatformAdvanced } = useAccount();
  const user = useUser();
  const { showUsersAndRolesV2 = false } = useFlags();
  const { UserRoles } = store;

  // Convert the user into a model so we can access computed properties
  const role =
    UserRoles.create({ ...user.get('role') }) ?? UserRoles.create({ id: EUserRoleIDs.User });

  /*
   * Has the right license to use permissions. This check is utilized to display
   * permissions-specific features like the roles pages.
   */
  const hasPermissionsLicenseOrFlag = showUsersAndRolesV2 || isPlatformAdvanced;

  return deriveRoleFlags(user, role, hasPermissionsLicenseOrFlag);
}

export default useRole;
